export function first(arr, defaultValue = null) {
    if (arr == null) return defaultValue
    return arr.length > 0 ? arr[0] : defaultValue
}

export function groupBy(arr, keyMapper, valueMapper = null) {
    return arr.reduce((res, row) => {
        const key = keyMapper(row)

        if (!(key in res)) {
            res[key] = []
        }

        const value = valueMapper ? valueMapper(row) : row
        res[key].push(value)
        return res
    }, {})
}

export function getOrDefault(obj, key, defaultValue) {
    if (obj == null)
        return defaultValue

    if (key in obj) {
        return obj[key]
    }

    return defaultValue
}

export function queryStringToObject(v) {
    return Object.fromEntries(new URLSearchParams(v).entries())
}
